import Repository from './Repository'

const course = 'course'
const get_courses_with_enrolledcount = 'course/getcourseswithenrolledcount'
const count = `booking/count`
const create_corporate_booking = `booking/import`
const create_member_booking = `booking/create`
const check_alipay_payment = `booking/checkalipaypayment`

export default {
    // Fetch Courses
    fetchCourses() {
        return Repository.get(`${course}`)
    },

    // Get Courses With Enrolled Count
    getCoursesWithEnrolledCount() {
        return Repository.get(`${get_courses_with_enrolledcount}`)
    },

    // Fetch Total Members
    getTotalMembers(payload) {
        return Repository.post(`${count}`, payload)
    },

    createCorporateBooking(payload) {
        return Repository.post(`${create_corporate_booking}`, payload)
    },

    // Create Member Booking
    createMemberBooking(payload) {
        return Repository.post(`${create_member_booking}`, payload)
    },

    // Check Alipay Payment
    checkAlipayPayment(payload) {
        return Repository.post(`${check_alipay_payment}`, payload)
    },
}